import React from 'react';

import classNames from 'classnames/bind';
import style from './Spreader.scss';
const ctx = classNames.bind(style);

const Spreader = props => (
  <div
    className={ctx('spreader', {
      'spreader--isWide': props.isWide,
      'spreader--isDisappear': props.isDisappear,
    })}
    style={props.style}
  >
    {props.children}
  </div>
);

export default Spreader;
